import React from 'react';
import classes from './Slider.module.css';
const Slider = props => {
    return (
        <div className={classes['slider-area']}>
            <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                </div>
                <div className="carousel-inner text-center text-white  ">
                    <div className="carousel-item active ">
                        <div className={`${classes.sliderarea} d-flex align-items-center justify-content-center`}>
                            <div className={classes.heading}><h2 className='animate__animated animate__backInDown '>Welcome To</h2>
                                <h3 className='animate__animated animate__bounce'>Devdanshu Dhaba</h3><a href="" className={`${classes["slider-button"]} animate__animated animate__backInUp`} data-toggle="modal">Book Now</a></div>
                        </div>
                    </div>
                    <div className="carousel-item">
                    <div className={`${classes.sliderarea} d-flex align-items-center justify-content-center`}>
                    <div className={classes.heading}>
                        <h2 className='animate__animated animate__backInDown '>Our Menu</h2>
                                <h3 className='animate__animated animate__bounce'>See What's New Today</h3><a href="" className={`${classes["slider-button"]} animate__animated animate__backInUp`} data-toggle="modal">Today's Menu</a></div>
                        </div>
                    </div>
                    <div className="carousel-item">
                    <div className={`${classes.sliderarea} d-flex align-items-center justify-content-center`}>
                            <div className={classes.heading}><h2 className='animate__animated animate__backInDown '>Get Ready</h2>
                                <h3 className='animate__animated animate__bounce'>to join with us</h3><a href="" className={`${classes["slider-button"]} animate__animated animate__backInUp`} data-toggle="modal">Reservation Now</a></div>
                        </div>
                    </div>
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    )
}
export default Slider;